import { http, HttpResponse } from 'msw';

export const encryptHandlers = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/encrypt', async ({ request }) => {
        const requestJson = await request.json();
        return HttpResponse.text(btoa(JSON.stringify(requestJson)));
    }),
];
